/* bb-cta-track.js — PDP CTA unique-click tracking into the bl-cdp first-party CDP.
   Added 2026-09-10.

   Fires two NAMED events to /apps/blt/e (same collector the tracker's bl-track.js
   uses), so they ride the existing consent gate + identity resolution + queue→D1
   pipeline:
     find_in_store_click  — click on "Find in Store" ([data-bpdp-find-store])
     add_to_cart_click    — click on "Add to Cart"   ([data-bpdp-ab-add], intent=add)

   The bl-cdp worker (worker.js handleEvents):
     - consent-gates server-side via the signed bl_consent cookie (analytics===true),
       so ONLY consented visitors are recorded (same posture as all CDP tracking);
     - resolves the canonical aid from the HttpOnly bl_aids mirror (our body.aid is
       only a fallback);
     - queues the envelope → R2 + Analytics Engine, and the queue consumer projects
       these two event types into D1 web_event (visitor_id = bl_aid) once they're in
       journey-d1.js CURATED_BASE → enabling COUNT(DISTINCT visitor_id / person_id).

   Design notes:
     - Loaded external + data-cfasync="false" so Cloudflare Rocket Loader leaves it
       alone (matches google-store-widget.js; inline scripts aren't reliably excluded).
     - sid is INTENTIONALLY omitted: a sid would make journey-d1 UPSERT web_session,
       and a click-only (no-pageview) envelope could create an attribution-less
       session row that the tracker's ON CONFLICT won't backfill. Omitting sid keeps
       the click in web_event (visitor-level) with zero risk to session/attribution.
     - Capture-phase listener so we fire before any handler that stops propagation.
     - Fully wrapped in try/catch — must never break the PDP. */
(function () {
  var EP = '/apps/blt/e';
  var lastFire = {}; // per-event throttle to de-noise rapid double-fire
  var fired = {};    // see the find_in_store_click guard in send() — once per product per page

  function cookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]+)'));
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }

  function productHandle() {
    try {
      var m = location.pathname.match(/\/products\/([^\/?#]+)/);
      return m ? m[1] : null;
    } catch (e) { return null; }
  }

  function productId() {
    try {
      var p = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
      return (p && p.id) ? p.id : null;
    } catch (e) { return null; }
  }

  function send(type, placement) {
    try {
      var now = Date.now();
      if (lastFire[type] && (now - lastFire[type]) < 600) return; // ignore accidental double-clicks
      lastFire[type] = now;

      /* ⚠ FIND IN STORE IS COUNTED ONCE PER PRODUCT PER PAGE VIEW. Added 20 Sep 2026.
         Measured over 7 days of live data: add_to_cart_click came back as a normal curve —
         363 visitors clicked once, 134 twice, 88 three times, tailing off at 8.
         find_in_store_click came back clustered at 121 and 131 clicks PER VISITOR.
         Same listener, same throttle, opposite shapes — so the fault is not in this file:
         [data-bpdp-find-store] sits on the store PANEL rather than on the button, and
         closest() therefore matches every tap inside it — each store row, each Directions
         link, each size chip. 60,948 recorded "clicks" in 30 days were really ~2,300 presses.
         MOVING THAT ATTRIBUTE ONTO THE BUTTON IS THE REAL FIX and belongs in the PDP markup.
         This guard makes the number usable now and stays correct after that fix lands, because
         "did this visitor ask to find this product in a store" is a yes/no, not a tally.
         ⚠ NOT applied to add_to_cart_click: there, repeat clicks are real information —
         somebody trying several sizes — and collapsing them would throw that away. */
      if (type === 'find_in_store_click') {
        var once = type + '|' + (productHandle() || location.pathname);
        if (fired[once]) return;
        fired[once] = 1;
      }

      var ev = { t: type, ts: now, pl: placement, url: location.pathname };
      var h = productHandle(); if (h) ev.h = h;
      var pid = productId();   if (pid) ev.pid = pid;

      var body = { ev: [ev] };
      var aid = cookie('bl_aid'); // worker prefers the HttpOnly bl_aids mirror; this is a fallback
      if (aid) body.aid = aid;

      var payload = JSON.stringify(body);
      // sendBeacon first (survives page unload), fetch keepalive fallback. Same-origin
      // so the signed bl_consent + bl_aids cookies ride along for server-side gating.
      try {
        var blob = new Blob([payload], { type: 'text/plain;charset=UTF-8' });
        if (navigator.sendBeacon && navigator.sendBeacon(EP, blob)) return;
      } catch (e2) { /* fall through to fetch */ }
      fetch(EP, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: payload,
        keepalive: true,
        credentials: 'include',
        mode: 'same-origin'
      }).catch(function () {});
    } catch (e) { /* never break the PDP */ }
  }

  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      var find = t.closest('[data-bpdp-find-store]');
      if (find) { send('find_in_store_click', find.classList.contains('bpdp-sticky-half') ? 'sticky' : 'inline'); return; }
      var add = t.closest('[data-bpdp-ab-add]');
      if (add) { send('add_to_cart_click', add.classList.contains('bpdp-sticky-half') ? 'sticky' : 'inline'); return; }
    } catch (err) { /* no-op */ }
  }, true);
})();
